<!-- 首页大底方案列表组件 -->
<template>
    <div>
        <div class="swipe-wrapper">
            <van-swipe class="card-swipe" :width="screenWidth * 0.88" :loop="false" :show-indicators="true">
                <van-swipe-item v-for="(item, index) in myArray" :key="index">
                    <div class="card">

                        <!-- 列表区 -->
                        <div class="case-list">
                            <!-- 遍历item -->
                            <div v-for="i in item" :key="i.id" class="case-item"
                                @click="toDetail(i.id)">
                                <!-- Item行 -->
                                <van-row v-if="i.headImg!=='more'" class="item-row">
                                    <!-- 头像列 -->
                                    <van-col span="4" class="col-center">
                                        <van-image class="head-img" round fit="cover" width="40" height="40"
                                            :src="'/img/headImg/' + i.headImg" />
                                    </van-col>
                                    <!-- 内容列 -->
                                    <van-col span="19" class="content">
                                        <!-- 内容列第1行 -->
                                        <van-row type="flex" justify="space-between" class="item-row1">
                                            <van-col span="8" class="col-center font1">
                                                <div class="van-ellipsis">{{ i.nickName }}</div>
                                            </van-col>
                                            <van-col span="16" class="col-center algin-right">
                                                <van-tag v-if="i.upIssueWinResult !== ''" plain type="danger"
                                                    class="mytag van-ellipsis">上期预测 ▪ 中{{ i.upIssueWinResult | commaFilter
                                                    }}</van-tag>
                                            </van-col>
                                        </van-row>
                                        <!-- 内容列第2行 -->
                                        <van-row type="flex" justify="space-between" class="item-row2">
                                            <van-col span="19" class="col-center font3 lh">
                                                <div class="van-multi-ellipsis--l2">{{ i | titleFilter }}</div>
                                            </van-col>
                                            <van-col v-if="i.requiredAmount > 0" span="5"
                                                class="col-center algin-right money">
                                                🪙{{ i.requiredAmount }}
                                            </van-col>
                                        </van-row>
                                    </van-col>
                                    <!-- 箭头列 -->
                                    <van-col span="1" class="col-center"><van-icon name="arrow"
                                            color="#ccc" /></van-col>
                                </van-row>
                                <!-- 更多行 -->
                                 <!-- 整行 -->
                                <van-row v-else style="height: 40px;" @click="toRecommend()">
                                    <!-- 头像列 -->
                                    <van-col span="4" class="col-center">
                                        <van-icon name="more" size="40" color="#ccc" />
                                    </van-col>
                                    <!-- 内容列 -->
                                    <van-col span="19" style="display: flex; align-items: center; height: 100%;">
                                        点我查看更多
                                    </van-col>
                                    <!-- 箭头列 -->
                                     <van-col span="1" class="col-center"><van-icon name="arrow" color="#ccc" /></van-col>
                                </van-row>
                            </div>
                        </div>
                    </div>

                </van-swipe-item>
            </van-swipe>
        </div>

    </div>
</template>

<script>
import Vue from 'vue';
import { Icon, Image as VanImage, Col, Row, Tag, Divider, CountDown } from 'vant';

Vue.use(Icon);
Vue.use(VanImage);
Vue.use(Col);
Vue.use(Row);
Vue.use(Tag);
Vue.use(Divider);
Vue.use(CountDown);

export default {
    name: 'CaseListSwipe',
    props: {
        areaId: {
            type: Number,
            default: 1,
        },
        postList: {
            type: Array,
            default: () => [] //注意这里要有默认值，否则会由于父组件异步加载迟缓而造成子组件提前使用的undefined
        }
    },
    data() {
        return {
            time: 30 * 60 * 60 * 1000,
            screenWidth: window.innerWidth,
        }
    },
    computed: {
        myArray() {
            // ✅ 空值保护
            if (!this.postList || this.postList.length === 0) {
                return []
            }
            // 将长数组转换成多个小数组，每个小数组里只放5条数据
            // 创建一个新数组存放结果
            const result = []
            const size = 5
            // 从索引 0 开始，以 size 为步长遍历原数组
            for (let i = 0; i < this.postList.length; i += size) {
                // 截取从 i 到 i+size 的一段，放入结果中
                result.push(this.postList.slice(i, i + size))
            }
            // 在最后一个子数组里加一个更多项
            result[result.length - 1].push({
                headImg: 'more',
                nickName: '查看更多',
            })
            return result
        },
    },
    filters: {
        // 如果没有标题，就以彩种名和期号为标题
        titleFilter(v) {
            if (v.title.trim() !== '') return v.title
            return v.nickName + v.lotteryName + '第' + v.issue + '期'
        },
        // 去掉逗号
        commaFilter(v) {
            return v.replace(/,/g, ' ')
        },
    },
    mounted() {
        window.addEventListener('resize', () => {
            this.screenWidth = window.innerWidth;
        });
    },
    methods: {
        // 查看特征
        toDetail(id){
            this.$router.push({
                path: '/detail',
                query: { id}
            })
        },

        // 查看更多
        toRecommend(){
            this.$router.push({
                path: '/recommend',
                query: { areaId: this.areaId}
            })
        },
    },
}
</script>

<style scoped>
.mytag {
    display: block;
    width: 90%;
}

.mytag::v-deep.van-tag--plain::before {
    border: none;
}

.case-item {
    background: #FFF3F3;
    border-radius: 8px;
    padding: 12px 8px 8px 8px;
    margin-top: 16px;
    margin-left: 5px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
}

/* 专家样式 */
.title-row {
    line-height: 20px;
}

.title-row .icon-box {
    display: inline-block;
    height: 20px;
    width: 8px;
    border-radius: 3px 0 0 3px;
    background-color: #F54B4A;
}

.title-row span.title {
    display: inline-block;
    height: 20px;
    line-height: 20px;
    position: absolute;
    margin-left: 3px;
    font-size: 18px;
    font-weight: 700;
    color: #202020;
}

.title-row .col-right {
    text-align: right;
}

.title-row .col-right span {
    margin-right: 1px;
    font-size: 14px;
    font-weight: 500;
    color: #9A9A9A;
}

.item-row {
    height: 56px;
}

.item-row1 {
    height: 24px;
    width: 100%;
}

.item-row2 {
    height: 26px;
    width: 100%;
}

.content {
    padding: 0 5px;
}

.head-img {
    width: 100%;
}

.lh {
    line-height: 16px;
}

.item-content {
    padding: 5px 0;
}

.count-down {
    color: #9A9A9A;
}

.money {
    color: #F54B4A;
    font-size: 14px;
}

.time {
    margin-top: 5px;
    margin-left: 3px;
    color: #F54B4A;
}

.col-center {
    display: flex;
    align-items: center;
    height: 100%;
}

.font-middling {
    font-size: 13px;
}

.algin-right {
    justify-content: flex-end;
}

/* 以下全是轮播器要用的样式 */
.swipe-wrapper {
    overflow: hidden;
    padding: 0 0 10px 0;
    /* margin-right: -16px; */
}

/* ✅ 关键样式：让第一张卡片紧贴左边 */
.card-swipe {
    padding-left: 0 !important;
    padding-right: 0;
    padding-bottom: 32px;/* 该值可以控制选择器垂直位置 */
}

/* ✅ 每个卡片：右侧间距产生间隔，左侧无间距 */
.van-swipe-item {
    padding-right: 12px;
    /* 卡片之间的间隔 */
    padding-left: 0;
    box-sizing: border-box;
}

/* 卡片样式 */
.card {
    border-radius: 8px;
    padding: 6px 5px 6px 0px;
    color: #202020;
    /* box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15); */
}

.card-icon {
    font-size: 36px;
    margin-bottom: 12px;
}

.card h3 {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 6px;
}

.card p {
    font-size: 11px;
    opacity: 0.75;
}

/* 自定义指示器样式 */
::v-deep .van-swipe__indicator {
    background: #000;
    width: 6px;
    height: 6px;
}

::v-deep .van-swipe__indicator--active {
    background: #667eea;
    width: 12px;
    border-radius: 3px;
}

.van-tag--plain {
    padding: 2px;
}
</style>